import _ from 'lodash';
import jQuery from 'jquery';

import filePickerLib from 'lib/filepicker';

function FilePickerDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    require: 'ngModel',
    template: `
<div class="file-picker-drag-and-drop">
  <div class="drop-pane" ng-show="!url && !imageUploading">
    <div class="drop-pane-inner">
      <p class="center">
        Drag and drop your image here
      </p>
      <p class="camera-icon center">
        <i class="ion-camera"></i>
      </p>
      <p>
        or click <a class="upload-link" href="#" ng-click="pickImage($event)">here</a> to select an image.
      </p>
    </div>
    <div class="drop-pane-upload">
      <p>Drop your image here to upload.</p>
    </div>
  </div>
  <div class="drag-and-drop-progress" ng-show="imageUploading">
    <p class="center">
      Uploading...
    </p>
    <div class="progress">
      <div class="progress-bar" ng-style="{ 'width' : (imageUploadedPercent + '%') }">
      </div>
    </div>
  </div>
</div>
    `,
    link: (scope, element, attrs, ngModelCtrl) => {
      scope.url = null;
      scope.imageUploading = false;
      scope.imageUploadedPercent = 0;

      ngModelCtrl.$render = function () {
        scope.url = ngModelCtrl.$viewValue || null;
      };

      //initialize the drop panel
      const $el = jQuery(element);
      const dropPane = $el.find('.drop-pane');

      scope.initDropPane = function () {
        filePickerLib.makeDropPane(dropPane[0], {
          multiple: false,
          dragEnter() {
            scope.$apply(() => scope.showDropPane());
          },
          dragLeave() {
            scope.$apply(() => scope.hideDropPane());
          },
          onSuccess(...args) {
            console.log('success', ...args);
            scope.$apply(() => scope.onImageUploaded(...args));
          },
          onProgress(...args) {
            scope.$apply(() => scope.onImageUploadProgress(...args));
          }
        });
      };

      scope.showDropPane = function () {
        dropPane.find('.drop-pane-inner').hide();
        dropPane.find('.drop-pane-upload').show();
        dropPane.css({
          backgroundColor: '#E0E0E0',
          border: '1px solid red'
        });
      };

      scope.hideDropPane = function () {
        dropPane.find('.drop-pane-inner').show();
        dropPane.find('.drop-pane-upload').hide();
        dropPane.css({
          backgroundColor: 'transparent',
          border: '1px dashed #777777'
        });
      };

      scope.pickImage = function ($event) {
        if ($event) {
          $event.preventDefault();
        }

        filePickerLib.pick()
          .then((...args) => {
            $timeout(() => this.onImageUploaded(...args));
          });
      };

      scope.onImageUploadProgress = function (percentage) {
        scope.imageUploading = true;

        scope.imageUploadedPercent = percentage;

        if (scope.imageUploadedPercent === 100) {
          scope.imageUploading = false;
        }
      };

      scope.onImageUploaded = function (result) {
        if (!result) return;

        scope.url = _.isArray(result) && result.length ? result[0].url : result.url;

        ngModelCtrl.$setViewValue(scope.url);
        ngModelCtrl.$dirty = true;

        $timeout(() => {
          scope.imageUploading = false;
          scope.imageUploadedPercent = 0;
          scope.hideDropPane();
        }, 200);
      };

      scope.initDropPane();
    }
  };
}

FilePickerDirective.$inject = [
  '$timeout'
];

export default FilePickerDirective;



// WEBPACK FOOTER //
// ./src/directives/filePickerDragAndDrop.js